if (!customElements.get('coupon-purchase')) {
    class CouponPurchase extends HTMLElement {
        constructor() {
            super();
            this.blockId = this.dataset.blockId || '';
            this.variantRadios = this.querySelectorAll(`input[name='coupon-purchase-variant-radio-${this.blockId}']`);
            this.originalPriceEl = this.querySelector('[data-original-price]');
            this.finalPriceEl = this.querySelector('[data-final-price]');
            this.buttonSavingsEl = this.querySelector('[data-button-savings]');
            this.productTitleEl = this.querySelector(`.ai-coupon-purchase-product-title-${this.blockId}`);
            this.addToCartBtn = this.querySelector('[data-add-to-cart]');
            this.functionType = this.dataset.functionType || 'multiple_variants_color';
            this.oneVariantId = (this.dataset.oneVariantId || '').trim();
            this.discountType = this.dataset.discountType || 'percentage';
            this.discountValue = Number(this.dataset.discountValue || 0);
            this.couponCode = this.dataset.couponCode || '';
            this.shop = this.dataset.shop || 'jp';
            this.couponPurchaseBaseUrl = this.dataset.baseUrl || '';

        }

        connectedCallback() {
            if (this.variantRadios.length) {
                this.variantRadios.forEach((radio) => {
                    radio.addEventListener('change', this.handleVariantChange.bind(this));
                });

                const checkedRadio = this.querySelector(`input[name='coupon-purchase-variant-radio-${this.blockId}']:checked`);
                if (checkedRadio) {
                    const checkedPrice = parseInt(checkedRadio.dataset.price, 10);
                    if (!Number.isNaN(checkedPrice)) {
                        this.updatePrices(checkedPrice);
                    }
                    this.updateProductTitle(checkedRadio.dataset.variantName || '');
                }
            }

            if (this.addToCartBtn) {
                this.addToCartBtn.addEventListener('click', this.handleAddToCart.bind(this));
            }
        }

        handleVariantChange(event) {
            const price = parseInt(event.target.dataset.price, 10);
            if (Number.isNaN(price)) {
                return;
            }

            this.updatePrices(price);
            this.updateProductTitle(event.target.dataset.variantName || '');
        }

        updateProductTitle(variantName) {
            if (!this.productTitleEl || !variantName) {
                return;
            }

            this.productTitleEl.textContent = variantName;
        }

        getSelectedVariantId() {
            if (this.functionType === 'one_variant') {
                return this.oneVariantId || (this.addToCartBtn ? this.addToCartBtn.dataset.productId : null);
            }

            const checkedRadio = this.querySelector(`input[name='coupon-purchase-variant-radio-${this.blockId}']:checked`);
            if (checkedRadio) {
                return checkedRadio.value;
            }

            return this.addToCartBtn ? this.addToCartBtn.dataset.productId : null;
        }

        updatePrices(originalPrice) {
            let finalPrice;
            let discountAmount;

            if (this.discountType === 'percentage') {
                const discountMultiplier = (100 - this.discountValue) / 100;
                finalPrice = Math.round(originalPrice * discountMultiplier);
                discountAmount = originalPrice - finalPrice;
            } else {
                discountAmount = this.discountValue * 100;
                finalPrice = originalPrice - discountAmount;
            }

            finalPrice = Math.max(0, finalPrice);
            discountAmount = Math.max(0, originalPrice - finalPrice);

            if (this.originalPriceEl) {
                this.originalPriceEl.textContent = this.formatMoney(originalPrice);
            }

            if (this.finalPriceEl) {
                this.finalPriceEl.textContent = this.formatMoney(finalPrice);
            }

            if (this.buttonSavingsEl) {
                this.buttonSavingsEl.textContent = this.formatMoney(discountAmount);
            }
        }

        formatMoney(cents) {
            const amount = cents / 100;
            return '¥' + amount.toLocaleString('ja-JP', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            });
        }

        handleAddToCart() {
            const variantId = this.getSelectedVariantId();
            if (!variantId) {
                return;
            }
            this.querySelector('.product-coupon-submit-loading').classList.toggle('tw-hidden');
            httpRequest.post('/business/shopify/checkout', {
                shop: this.shop,
                discountCodes: [this.couponCode],
                lineItems: [{
                    variantId: variantId,
                    quantity: 1,
                }]
            }, {
                baseUrl: this.couponPurchaseBaseUrl
            }).then((res) => {

                if (res.code == 200 && res.data) {
                    window.location.href = res.data.invoiceUrl;
                } else {
                    zzShowToast('ネットワークエラー、後で再度お試しください');
                }
            }).catch((err) => {
                zzShowToast('ネットワークエラー、後で再度お試しください');
            }).finally(() => {
                this.querySelector('.product-coupon-submit-loading').classList.toggle('tw-hidden');
            });
        }
    }

    customElements.define('coupon-purchase', CouponPurchase);
}